import { useLazyQuery } from 'src/graphql';
import { SURVEY_BY_CODE } from 'src/graphql/survey/query';

export default (variables) =>
  useLazyQuery(SURVEY_BY_CODE,{
    variables,
    fetchPolicy: 'network-only',
  }, false, true);